<script>
	import Helper from '../../Models/Helper';
	import Product from '../../States/Product';

	function back(event) {
		$Product.options = false;
		$Product.basket = false;
		$Product.info = false;
	}
</script>

<style>
	div.phd-info {
		font-size: 1.25em;
	}

	div.phd-info img {
		max-width: 100%;
	}

	div.phd-secondary svg {
		width: .7em;
		vertical-align: middle;
		margin-right: .25em;
	}
</style>

{#if Helper.is($Product.api)}
	<div class="phd-layout">
		<div class="phd-header phd-duo">
			<div>
				<span>Deurmodel</span> {$Product.api.name}
				<div>Incl. meten en monteren</div>
			</div>
			<div>€ {$Product.price}</div>
		</div>
		<div class="phd-body">
			<div class="phd-info">
				{#if $Product.info}
					{@html $Product.api.info}
				{/if}
			</div>
		</div>
		<div class="phd-footer">
			<div class="phd-button phd-secondary" on:click="{back}">
				<svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg>
				Terug
			</div>
		</div>
	</div>
{/if}